import { useQuery } from '@tanstack/react-query';
import { useMatches } from '@tanstack/react-router';

export function useSystemPrompts(): string[] {
  const matches = useMatches();

  const { data: systemPrompts = [] } = useQuery({
    queryKey: ['chatContext', matches] as const,
    queryFn: ({ queryKey: [, matches] }) =>
      Promise.all(matches.map((match) => match.loaderData?.chatContext).filter((it) => it !== undefined)),
    select: (data) => data.map(({ systemPrompt }) => systemPrompt).filter((prompt) => prompt !== undefined),
  });

  return systemPrompts;
}
